import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-dropdown-menu-item',
    templateUrl: './dropdown-menu-item.component.html',
    styleUrls: ['./dropdown-menu-item.component.scss'],
    standalone: false
})
export class DropdownMenuItemComponent {

  @Input() icon;
  @Input() text;
  @Input() disabled;

  get isMaterialIcon(): boolean {
    return !this.icon.startsWith('icon-');
  }

}
